import React, { useCallback, useEffect, useRef, useState } from "react";
import "photoswipe/style.css";
import { useGetAllPublicNoticesQuery } from "../../Redux/getApi";
import PublicNoticeCard from "./PublicNoticeCard";
import Announcement from "./Announcement";

const PublicNotices = () => {
  const [page, setPage] = useState(1);
  const [items, setItems] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  const { data, error, isFetching, isLoading } = useGetAllPublicNoticesQuery({
    page,
    limit: 10,
  });

  useEffect(() => {
    if (data) {
      setItems((prev) => {
        const existingIds = new Set(prev.map((item) => item._id));
        const newItems = data.publicNotices.filter(
          (item) => !existingIds.has(item._id)
        );
        return [...prev, ...newItems];
      });
      setHasMore(page < data.totalPages);
    }
  }, [data, page]);

  const observer = useRef();
  const lastElementRef = useCallback(
    (node) => {
      if (isFetching) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prev) => prev + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [isFetching, hasMore]
  );

  const loading = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <div className="flex flex-col lg:gap-10 md:gap-6 gap-4 xl:py-20 lg:py-14 sm:py-10 py-6  xl:px-[5%] lg:px-[3%] md:px-[3%] px-[6%] ">
      <div className="xl:text-[2.5rem] lg:text-[1.8rem] text-[1.6rem]  capitalize text-center font-bold">
        public notices / news for awareness
      </div>
      <Announcement />
      {isFetching || isLoading
        ? page === 1 && (
            <div className=" grid 2xl:grid-cols-5 xl:grid-cols-4 md:grid-cols-3 sm:grid-col-2 grid-cols-1 lg:gap-3 gap-2">
              {loading.map((i) => (
                <div
                  key={i}
                  className=" w-full aspect-square bg-[#efefef] animate-pulse rounded-xl"
                ></div>
              ))}
            </div>
          )
        : items && (
            <div className="grid 2xl:grid-cols-5 lg:grid-cols-4  md:grid-cols-3 sm:grid-col-2 grid-cols-1 gap-6">
              {items?.map((publicNotice, index) => (
                <div
                  key={publicNotice?._id}
                  ref={index === items.length - 4 ? lastElementRef : null}
                  className="flex"
                >
                  <PublicNoticeCard publicNotice={publicNotice} />
                </div>
              ))}
            </div>
          )}
      {isFetching && (
        <p className="text-center text-white bg-[#afacac] py-3 px-5 rounded-full w-max mx-auto font-bold">
          Loading more...
        </p>
      )}
      {data?.publicNotices?.length === 0 ? (
        <div className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#000000]">
          No Notice Found
        </div>
      ) : (
        !hasMore && (
          <p className="text-center text-white bg-black py-3 px-5 rounded-full w-max mx-auto font-bold ">
            No more notices
          </p>
        )
      )}
      {}
      {error && (
        <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
          {error?.data?.message || error?.data?.error}
        </p>
      )}
    </div>
  );
};

export default PublicNotices;
